import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './styles/typography.css';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from "./contexts/config";

const Application = () => {
  return (
    <ConfigProvider>
      <App />
    </ConfigProvider>
  );
};

ReactDOM.createRoot(document.getElementById("root")).render(<Application />);



reportWebVitals();
